import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { WingFoilCampaignPage } from './pages/WingFoilCampaignPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
import { CorporateTeamBuildingPage } from './pages/CorporateTeamBuildingPage';
import { MensMorningOnWaterPage } from './pages/MensMorningOnWaterPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="35ovwnmbgyrj">
      <ScrollToTop data-id="element-1" data-mp="356rv4texg92" />
      <Routes data-id="element-2" data-mp="34ncnvv5d5yq">
        <Route path="/" element={<BeachClubPage data-id="element-4" data-mp="3ud1e95yxri91" />} data-id="element-3" data-mp="38b50rouvmbv" />
        <Route path="/sup" element={<SUPPage data-id="element-6" data-mp="3ucjehzd2elwd" />} data-id="element-5" data-mp="3ubriinfk2m5k" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" data-mp="d4xopd5g47cb" />} data-id="element-7" data-mp="d4nxjm8nzu51" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" data-mp="d2bh5dik1ru3" />} data-id="element-9" data-mp="d45rxz0443kg" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" data-mp="86w60tbxma1d" />} data-id="element-11" data-mp="851lvh8hilyc" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" data-mp="3gl4qtf87pwiz" />} data-id="element-13" data-mp="83i1pfjpjqra" />
        <Route path="/wingfoil-campaign" element={<WingFoilCampaignPage data-id="element-16" data-mp="3gja35t5k3qb7" />} data-id="element-15" data-mp="3gmfvdh9hf8b5" />
        <Route path="/events" element={<EventsPage data-id="element-18" data-mp="3bnmerfywf16r" />} data-id="element-17" data-mp="3bmthr6pqrq1t" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-20" data-mp="3qbppt3rst32f" />} data-id="element-19" data-mp="3bk70uggyny6x" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-22" data-mp="3qd0st1df66sh" />} data-id="element-21" data-mp="3qbzd2jlgkw4f" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-24" data-mp="3liwkoesf3spt" />} data-id="element-23" data-mp="3ljxw4kdcih82" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-26" data-mp="2xu3ii0l7comr" />} data-id="element-25" data-mp="3limuor7dhlk4" />
        <Route path="/admin" element={<AdminDashboard data-id="element-28" data-mp="2xsk1u8vmwbkg" />} data-id="element-27" data-mp="2xtbyln0ywfcb" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-30" data-mp="2svaecyrt29z9" />} data-id="element-29" data-mp="2swbsjc44bcl7" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-32" data-mp="18czmmhs8vbly" />} data-id="element-31" data-mp="18e1ajmuczsl3" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-34" data-mp="1d5jac7knbn4h" />} data-id="element-33" data-mp="18bya08vkyh24" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-36" data-mp="yg3kctsxvlpu" />} data-id="element-35" data-mp="1d6aw6qofy6hk" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-38" data-mp="ydqwk00i2h4v" />} data-id="element-37" data-mp="yh6dl8dqi08x" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-40" data-mp="13f7y7xqt67mi" />} data-id="element-39" data-mp="13e56jnlnw15j" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-42" data-mp="1r5kcdqcnd0lj" />} data-id="element-41" data-mp="1r496nkzn5irs" />
        <Route path="/team-building" element={<CorporateTeamBuildingPage data-id="element-44" data-mp="1w3vk9vjdt114" />} data-id="element-43" data-mp="1r266w98osb9v" />
        <Route path="/mens-morning-on-water" element={<MensMorningOnWaterPage data-id="element-46" data-mp="1i3ukkjeurzn8" />} data-id="element-45" data-mp="1w2tzv0gh726q" />
      </Routes>
      <ConditionalFloatingButton data-id="element-47" data-mp="1i318r411ejy8" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on dedicated landing and payment pages
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water' || location.pathname === '/team-building' || location.pathname === '/wingfoil-campaign' || location.pathname === '/mens-morning-on-water') {
    return null;
  }
  if (location.pathname === '/events') {
    return <FloatingJoinButton label="השאירו פרטים" data-id="element-48" data-mp="19uoufgfwix3r" />;
  }
  return <FloatingJoinButton data-id="element-49" data-mp="14x6h7duupvpy" />;
}